import api from '../services/api';
import { IProduct, IProductCategory } from '../shared/interfaces';

interface IResponseGetProductsCategories {
  data: IProductCategory[];
  count: number;
}
export const getProductsCategories = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetProductsCategories> => {
  const response = await api.post('/products-categories/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const postProductCategory = async (payload: any): Promise<IProduct> => {
  const response = await api.post(`/products-categories`, payload);
  return response.data;
};

export const patchProductCategory = async (
  id: string | undefined,
  payload: any,
): Promise<IProduct> => {
  if (!id) {
    throw new Error('ID da categoria do produto não fornecido.');
  }
  const response = await api.patch(`/products-categories/${id}`, payload);
  return response.data;
};

export const getSelectProductCategories = async (): Promise<IProduct[]> => {
  const response = await api.get(`/products-categories/select/all`);
  return response.data;
};
